import { Box, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';

export default function BackClickBottomSheetTbm({
  open,
  ToggleDrawer,
  DeleteLogic1,
  ActiveButton,
}) {
  const { navigate } = useAppNavigate();

  return (
    <BottomSheet
      open={open}
      onClose={ToggleDrawer('bottom', false)}
      onOpen={ToggleDrawer('bottom', true)}
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          교육을 종료하시겠습니까?
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          지금까지 진행한 내용은 저장되지 않아요. <br /> 다시 진행해주세요.
        </Typography>
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          gap: 8,
        }}
      >
        <Button
          name="취소"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: 'transparent',
            border: `1px solid #776D6D`,
            color: '#776D6D',
            boxShadow: 'none',
          }}
          onClick={(e) => {
            ToggleDrawer('bottom', false)(e);
          }}
        />
        <Button
          name="확인"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={async (e) => {
            await DeleteLogic1();
            ToggleDrawer('bottom', false)(e);

            if (ActiveButton) {
              ActiveButton({
                type: 'end',
                content: true,
              });
            }

            navigate('/Home');
          }}
        />
      </Box>
    </BottomSheet>
  );
}
